/**
 * This file contains utilities and constants for the recordings
 */
import copy from 'copy-to-clipboard';
import {showShareRecordingClipboardNotification} from "../notifications/live";
import {showMakePublicPopup} from "../notifications/popup";

/* -----------------    Priority    ------------------ */
export const PRIORITY_HIGH = 'high';
export const PRIORITY_MEDIUM = 'med';
export const PRIORITY_LOW = 'low';
export const PRIORITY_NONE = 'none';

/* -----------------    Privacy    ------------------ */
export const PRIVACY_PUBLIC = "public";
export const PRIVACY_PRIVATE = "private";

/**
 * Handler for when any share button is clicked
 */
export const onShareRecording = (privacy, url, unitId, recordingId) => () => {
    if (privacy === PRIVACY_PUBLIC) {
        copy(url);
        showShareRecordingClipboardNotification();
    } else {
        showMakePublicPopup(unitId, recordingId, url);
    }
};

/**
 * Returns the expected recording type based on the
 * supplied {@param url}.
 */
export const getRecordingType = (url) => {
    if (url.includes('.m3u8')) {
        return 'application/x-mpegurl';
    } else if (url.includes('.mp4')) {
        return 'video/mp4';
    } else {
        return 'INVALID';
    }
};



// WEBPACK FOOTER //
// ./src/components/recording/utils.js